/* Antwerp Avenue – Bundles
 * One shared engine for the bundle page and the product-page bundle block.
 * - Categories, collections and percentages: snippets/aa-bundle-config.liquid,
 *   which reads Content > Metaobjects > Bundle settings.
 * - Prices mirror the automatic "Bundle saving: …" discounts (Admin > Discounts).
 * - A bundle = a list of slots ("+ Add card holder"). Each slot is filled in a
 *   step popup (1/3, 2/3 …) with search and product cards.
 * - Search uses Shopify search (templates/search.aa-bundle-feed.liquid), lists use
 *   collection feeds (templates/collection.aa-bundle-feed.liquid), 48 at a time.
 */
(function () {
  'use strict';
  if (window.AABundle) return;
  var cfgEl = document.getElementById('AaBundleConfig');
  if (!cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);
  var ROOT = (CFG.root || '/').replace(/\/?$/, '/');

  var DICT = {
    en: {
      cat: { case: 'Phone case', case2: 'Second phone case', cardholder: 'Card holder', sleeve: 'Sleeve', macbook: 'MacBook case', powerbank: 'Power bank', airpods: 'AirPods case', strap: 'Phone strap', holder: 'Phone holder', screen: 'Screen protector' },
      add: { case: 'Add phone case', case2: 'Add second phone case', cardholder: 'Add card holder', sleeve: 'Add sleeve', macbook: 'Add MacBook case', powerbank: 'Add power bank', airpods: 'Add AirPods case', strap: 'Add phone strap', holder: 'Add phone holder', screen: 'Add screen protector' },
      pick: { case: 'Choose a phone case', case2: 'Choose a second phone case', cardholder: 'Choose a card holder', sleeve: 'Choose a sleeve', macbook: 'Choose a MacBook case', powerbank: 'Choose a power bank', airpods: 'Choose an AirPods case', strap: 'Choose a phone strap', holder: 'Choose a phone holder', screen: 'Choose your screen protector' },
      variantLabel: { sleeve: 'size', macbook: 'MacBook', airpods: 'AirPods', screen: 'phone', case: 'case type', def: 'option' },
      chooseX: 'Choose your', change: 'Change', thisCase: 'This case', thisItem: 'This product',
      yourPhone: 'Your phone', selectModel: 'Choose your phone', modelFirst: 'Choose your phone first, then pick your design.',
      loadMore: 'Show more', loading: 'Loading…', soldOut: 'Sold out',
      search: 'Search', noResults: 'Nothing found. Try another word?', close: 'Close',
      notForModel: 'Not available for your phone in this style. Try another style or design?',
      regular: 'Regular price', bundle: 'Bundle price', save: 'You save', saveShort: 'Save',
      bundleSave: 'Up to {n}% off the extras', selectN: 'Select {n} products for your bundle',
      addItem: 'Add', added1: 'Added', addBundle: 'Add bundle to bag', adding: 'Adding…', added: 'Added to your bag',
      selectMore: 'Select {n} more', error: 'Something went wrong. Please try again.',
      from: 'From', build: 'Shop now', building: 'Selected',
      sizeHint: { Small: 'Fits iPad mini, Kindle Paperwhite', Medium: 'Fits iPad Air, iPad Pro 11"', Large: 'Fits MacBook Air 13", MacBook Pro 13"/14", iPad Pro 12.9"' }
    },
    nl: {
      cat: { case: 'Gsm-hoesje', case2: 'Tweede gsm-hoesje', cardholder: 'Kaarthouder', sleeve: 'Sleeve', macbook: 'MacBook case', powerbank: 'Powerbank', airpods: 'AirPods-hoesje', strap: 'Gsm-strap', holder: 'Gsm-houder', screen: 'Screenprotector' },
      add: { case: 'Voeg je gsm-hoesje toe', case2: 'Voeg een tweede hoesje toe', cardholder: 'Voeg een kaarthouder toe', sleeve: 'Voeg een sleeve toe', macbook: 'Voeg een MacBook case toe', powerbank: 'Voeg een powerbank toe', airpods: 'Voeg een AirPods-hoesje toe', strap: 'Voeg een gsm-strap toe', holder: 'Voeg een gsm-houder toe', screen: 'Voeg een screenprotector toe' },
      pick: { case: 'Kies je gsm-hoesje', case2: 'Kies je tweede hoesje', cardholder: 'Kies je kaarthouder', sleeve: 'Kies je sleeve', macbook: 'Kies je MacBook case', powerbank: 'Kies je powerbank', airpods: 'Kies je AirPods-hoesje', strap: 'Kies je gsm-strap', holder: 'Kies je gsm-houder', screen: 'Kies je screenprotector' },
      variantLabel: { sleeve: 'maat', macbook: 'MacBook', airpods: 'AirPods', screen: 'gsm', case: 'type hoesje', def: 'optie' },
      chooseX: 'Kies je', change: 'Wijzig', thisCase: 'Dit hoesje', thisItem: 'Dit product',
      yourPhone: 'Jouw gsm', selectModel: 'Kies je gsm', modelFirst: 'Kies eerst je gsm, daarna je design.',
      loadMore: 'Toon meer', loading: 'Laden…', soldOut: 'Uitverkocht',
      search: 'Zoeken', noResults: 'Niets gevonden. Probeer een ander woord?', close: 'Sluiten',
      notForModel: 'Niet beschikbaar voor jouw gsm in dit type. Kies een ander type of design?',
      regular: 'Normale prijs', bundle: 'Bundelprijs', save: 'Je bespaart', saveShort: 'Bespaar',
      bundleSave: 'Tot {n}% korting op je extra’s', selectN: 'Kies {n} producten voor je bundel',
      addItem: 'Toevoegen', added1: 'Gekozen', addBundle: 'Bundel in winkelmandje', adding: 'Toevoegen…', added: 'Toegevoegd aan je winkelmandje',
      selectMore: 'Kies nog {n}', error: 'Er ging iets mis. Probeer je het opnieuw?',
      from: 'Vanaf', build: 'Stel samen', building: 'Gekozen',
      sizeHint: { Small: 'Past voor iPad mini, Kindle Paperwhite', Medium: 'Past voor iPad Air, iPad Pro 11"', Large: 'Past voor MacBook Air 13", MacBook Pro 13"/14", iPad Pro 12.9"' }
    }
  };
  var T = DICT[CFG.lang] || DICT.en;

  /* ---------- helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var format = CFG.moneyFormat || '€{{amount_with_comma_separator}}';
    var v = (cents || 0) / 100;
    function f(n, dec, th, ds) {
      var p = n.toFixed(dec).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] ? ds + p[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var s;
    switch (m && m[1]) {
      case 'amount_no_decimals': s = f(v, 0, ',', '.'); break;
      case 'amount_with_comma_separator': s = f(v, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': s = f(v, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': s = f(v, 2, "'", '.'); break;
      default: s = f(v, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, s).replace(/<[^>]*>/g, '');
  }
  function img(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function cat(key) { return (CFG.categories || []).filter(function (c) { return c.key === key; })[0]; }
  function variantName(title) {
    if (!title || title === 'Default Title') return '';
    var parts = title.split(' / ');
    return parts[parts.length - 1];
  }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
  function fill(s, n) { return s.replace('{n}', n); }
  function store(k, v) {
    try { if (v === undefined) return localStorage.getItem('aa-bundle-' + k); localStorage.setItem('aa-bundle-' + k, v); } catch (e) { return null; }
  }

  /* ---------- pricing: mirrors the automatic Buy X Get Y discounts ---------- */
  /* items: [{type, price}] → totals + per-line discount (same order as items) */
  function price(items) {
    var lines = items.map(function (i, idx) {
      return { idx: idx, type: i ? i.type : null, price: i && i.price != null ? i.price : 0, discount: 0, ok: !!(i && i.price != null) };
    }).filter(function (l) { return l.ok; });
    function count(types) { return lines.filter(function (l) { return types.indexOf(l.type) > -1; }).length; }
    function applyTo(type, n, p) {
      lines.filter(function (l) { return l.type === type; })
        .sort(function (a, b) { return a.price - b.price; })
        .slice(0, n)
        .forEach(function (l) { l.discount = Math.max(l.discount, Math.round(l.price * p / 100)); });
    }
    (CFG.categories || []).forEach(function (c) {
      if (c.key === 'case' || !c.pct) return;
      var mine = count([c.key]);
      if (mine) applyTo(c.key, Math.min(mine, count(c.buys || ['case'])), c.pct);
    });
    var cases = count(['case']);
    if (CFG.secondCasePct && cases > 1) applyTo('case', Math.floor(cases / 2), CFG.secondCasePct);
    var original = lines.reduce(function (s, l) { return s + l.price; }, 0);
    var discount = lines.reduce(function (s, l) { return s + l.discount; }, 0);
    var per = [];
    lines.forEach(function (l) { per[l.idx] = l.discount; });
    return { original: original, discount: discount, total: original - discount, percent: original ? Math.round(discount / original * 100) : 0, lines: per };
  }
  /* best discount % a category can get inside a bundle (for "Bundle & save x%" labels) */
  function pctFor(key) {
    if (key === 'case2') return CFG.secondCasePct || 0;
    var c = cat(key);
    return c && c.pct ? c.pct : 0;
  }

  /* ---------- data ---------- */
  var feedCache = {};
  function feed(handle, page) {
    var key = handle + ':' + (page || 1);
    if (!feedCache[key]) {
      feedCache[key] = fetch(ROOT + 'collections/' + handle + '?view=aa-bundle-feed&page=' + (page || 1), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('feed'); return r.text(); })
        .then(function (t) { return JSON.parse(t); })
        .catch(function (e) { delete feedCache[key]; throw e; });
    }
    return feedCache[key];
  }
  var productCache = {};
  function product(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(ROOT + 'products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); })
        .catch(function (e) { delete productCache[handle]; throw e; });
    }
    return productCache[handle];
  }

  /* ---------- cart ---------- */
  function addToCart(items, bundleName) {
    var merged = {}, order = [];
    items.forEach(function (i) {
      if (!merged[i.variantId]) { merged[i.variantId] = 0; order.push(i.variantId); }
      merged[i.variantId] += 1;
    });
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: order.map(function (id) {
          return { id: Number(id), quantity: merged[id], properties: { _bundle: bundleName || 'Bundle' } };
        })
      })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || 'cart');
        return j;
      });
    }).then(function (j) {
      return applyCodes(items).catch(function () {}).then(function () { openCart(); return j; });
    });
  }
  /* bundle discounts are codes (BUNDLE-…), applied only when a bundle is added here */
  function applyCodes(items) {
    var want = [];
    var cases = items.filter(function (i) { return i.type === 'case'; }).length;
    items.forEach(function (i) {
      var c = cat(i.type);
      if (i.type !== 'case' && c && c.code && want.indexOf(c.code) < 0) want.push(c.code);
    });
    if (cases > 1 && CFG.secondCaseCode) want.push(CFG.secondCaseCode);
    if (!want.length) return Promise.resolve();
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var have = (cart.discount_codes || []).map(function (d) { return d.code; });
      var all = have.slice();
      want.forEach(function (c) { if (all.map(function (x) { return x.toUpperCase(); }).indexOf(c) < 0) all.push(c); });
      if (all.length === have.length) return;
      return fetch(ROOT + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: all.join(',') })
      });
    });
  }
  function openCart() {
    if (document.querySelector('m-cart-drawer') && document.querySelector('m-cart-items')) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
    } else {
      window.location.href = CFG.cartUrl || '/cart';
    }
  }

  function defaultVariant(type, variants) {
    variants = variants || [];
    var avail = variants.filter(function (v) { return v.available && !(type === 'powerbank' && /shell only|enkel hoesje/i.test(v.title)); });
    if (variants.length === 1 || type === 'powerbank') return avail[0] || null;
    if (type === 'sleeve') return avail.filter(function (v) { return /large/i.test(v.title); })[0] || avail[0] || null;
    return null; /* AirPods / MacBook models etc.: the customer must choose */
  }
  function priceHTML(orig, now, fromLabel) {
    return (fromLabel ? '<span class="aa-from">' + fromLabel + '</span> ' : '') +
      (now < orig ? '<s class="aa-was">' + money(orig) + '</s> <span class="aa-now">' + money(now) + '</span>' : '<span class="aa-now aa-now--plain">' + money(orig) + '</span>');
  }

  /* =========================================================
   * Bundle: a list of slots + the BURGA-style panel
   * opts: { title, slots:[{key, product, variant, fixed, model}], suggest:{key:[products]},
   *         models:[{model, collection, brand}], onChange }
   * ========================================================= */
  function Bundle(opts) {
    this.title = opts.title || '';
    this.slots = opts.slots.map(function (s) { return { key: s.key, type: s.key === 'case2' ? 'case' : s.key, product: s.product || null, variant: s.variant || null, fixed: !!s.fixed, model: s.model || '' }; });
    this.suggest = opts.suggest || {};
    this.magsafe = opts.slots.some(function (s) { return s.key === 'powerbank'; }); /* powerbank-bundel: alleen iPhone + MagSafe-hoesje */
    var MAGSAFE = ['iPhone 18 Pro Max', 'iPhone 18 Pro', 'iPhone 17 Pro Max', 'iPhone 17 Pro', 'iPhone 17 Air', 'iPhone 17', 'iPhone 16 Pro Max', 'iPhone 16 Pro', 'iPhone 16 Plus', 'iPhone 16', 'iPhone 15 Pro Max', 'iPhone 15 Pro', 'iPhone 15 Plus', 'iPhone 15', 'iPhone 14 Pro Max', 'iPhone 14 Pro', 'iPhone 14 Plus', 'iPhone 14', 'iPhone 13 Pro Max', 'iPhone 13 Pro', 'iPhone 13']; /* modellen met een MagSafe-hoesje */
    this.models = (opts.models || []).filter(function (m) { return !this.magsafe || MAGSAFE.indexOf(m.model) > -1; }, this);
    this.onChange = opts.onChange || function () {};
    this.el = null;
  }
  Bundle.prototype.items = function () {
    return this.slots.filter(function (s) { return s.variant; }).map(function (s) {
      return { type: s.type, variantId: s.variant.id, price: s.variant.price };
    });
  };
  Bundle.prototype.missing = function () { return this.slots.filter(function (s) { return !s.variant; }).length; };
  Bundle.prototype.steps = function () { return this.slots.filter(function (s) { return !s.fixed; }); };
  /* phone model of the case in this bundle (for the matching screen protector) */
  Bundle.prototype.caseModel = function () {
    var c = this.slots.filter(function (s) { return s.type === 'case' && s.variant; })[0];
    if (!c) return '';
    return c.model || String(c.variant.title || '').split(' / ')[0];
  };
  Bundle.prototype.maxPct = function () {
    return this.slots.reduce(function (m, s) { return Math.max(m, pctFor(s.key)); }, 0);
  };

  Bundle.prototype.render = function (el) {
    var self = this;
    if (el) this.el = el;
    el = this.el;
    if (!el) return;
    var all = this.slots.map(function (s) { return s.variant ? { type: s.type, price: s.variant.price } : null; });
    var priced = price(all);
    var missing = this.missing();
    var pct = this.maxPct();
    el.innerHTML = '<div class="aa-bp">' +
      '<div class="aa-bp__head"><p class="aa-bp__title">' + esc(this.title) + '</p>' +
      (pct ? '<span class="aa-badge">' + fill(T.bundleSave, pct) + '</span>' : '') + '</div>' +
      '<p class="aa-bp__intro">' + fill(T.selectN, this.slots.length) + '</p>' +
      '<ul class="aa-slots">' + this.slots.map(function (s, i) {
        var v = s.variant, p = s.product;
        var meta = '';
        if (v && s.type === 'case') meta = s.model ? s.model + ' · ' + (v.option2 || variantName(v.title)) : String(v.title || '').split(' / ').join(' · ');
        else if (v) meta = variantName(v.title);
        var pic = v && v.img ? v.img : (v && p ? p.img : null);
        var inner = '<span class="aa-slot__img">' + (pic ? '<img src="' + esc(img(pic, 200)) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="aa-slot__plus" aria-hidden="true">+</span>') + '</span>' +
          '<span class="aa-slot__text">' +
          (v ? '<span class="aa-slot__label">' + (s.fixed ? (s.type === 'case' ? T.thisCase : T.thisItem) : T.cat[s.key]) + '</span><span class="aa-slot__name">' + esc(p.title) + '</span>' + (meta ? '<span class="aa-slot__meta">' + esc(meta) + '</span>' : '')
            : '<span class="aa-slot__name">' + T.add[s.key] + '</span>' + (p && !v ? '<span class="aa-slot__meta aa-slot__meta--todo">' + esc(p.title) + ' · ' + T.chooseX + ' ' + (T.variantLabel[s.type] || T.variantLabel.def) + '</span>' : '')) +
          '</span>' +
          (v ? '<span class="aa-slot__price">' + priceHTML(v.price, v.price - (priced.lines[i] || 0)) + '</span>' : '') +
          (s.fixed ? '' : '<span class="aa-slot__action" aria-hidden="true">' + (v ? T.change : '') + '</span>');
        return '<li>' + (s.fixed ? '<div class="aa-slot is-filled is-fixed">' + inner + '</div>'
          : '<button type="button" class="aa-slot' + (v ? ' is-filled' : '') + '" data-slot="' + i + '" aria-label="' + esc(v ? T.change + ': ' + T.cat[s.key] + ', ' + p.title : T.add[s.key]) + '">' + inner + '</button>') + '</li>';
      }).join('') + '</ul>' +
      '<div class="aa-bp__totals" aria-live="polite">' + (priced.original ? (priced.discount ? '<div class="aa-sum__row"><span>' + T.regular + '</span><s>' + money(priced.original) + '</s></div>' : '') +
        '<div class="aa-sum__row aa-sum__row--total"><span>' + T.bundle + '</span><strong>' + money(priced.total) + '</strong></div>' +
        (priced.discount ? '<div class="aa-sum__save">' + T.save + ' ' + money(priced.discount) + ' <span>(' + priced.percent + '%)</span></div>' : '') : '') + '</div>' +
      '<button type="button" class="aa-btn" data-bp-add>' + (missing ? fill(T.selectMore, missing) : T.addBundle) + '</button>' +
      '<p class="aa-sum__status" role="status" aria-live="polite" data-bp-status></p></div>';
    el.querySelectorAll('[data-slot]').forEach(function (b) {
      b.addEventListener('click', function () { self.open(Number(b.getAttribute('data-slot'))); });
    });
    el.querySelector('[data-bp-add]').addEventListener('click', function () {
      var first = self.firstOpen(-1);
      if (first > -1) self.open(first);
      else if (self.missing()) { var st = el.querySelector('[data-bp-status]'); st.textContent = T.soldOut; st.classList.add('is-error'); }
      else self.add();
    });
  };
  Bundle.prototype.firstOpen = function (after) {
    for (var k = 1; k <= this.slots.length; k++) {
      var i = (after + k + this.slots.length) % this.slots.length;
      if (!this.slots[i].fixed && !this.slots[i].variant) return i;
    }
    return -1;
  };
  Bundle.prototype.open = function (i) { Picker.open(this, i); };
  Bundle.prototype.changed = function () { this.render(); this.onChange(this); };
  Bundle.prototype.focusAdd = function () { var b = this.el && this.el.querySelector('[data-bp-add]'); if (b) b.focus(); };
  Bundle.prototype.add = function () {
    var self = this;
    var btn = this.el.querySelector('[data-bp-add]');
    var status = this.el.querySelector('[data-bp-status]');
    btn.disabled = true; btn.textContent = T.adding;
    status.textContent = ''; status.classList.remove('is-error');
    addToCart(this.items(), this.title).then(function () {
      status.textContent = T.added;
    }).catch(function () {
      status.textContent = T.error; status.classList.add('is-error');
    }).then(function () { btn.disabled = false; btn.textContent = self.missing() ? fill(T.selectMore, self.missing()) : T.addBundle; });
  };

  /* =========================================================
   * Step popup: "1/3  Choose a card holder" + search + product cards
   * ========================================================= */
  var Picker = (function () {
    var el, input, grid, more, titleEl, stepEl, toolsEl, lastFocus, st;
    var lastName = {};
    function build() {
      el = document.createElement('div');
      el.className = 'aa-modal';
      el.hidden = true;
      el.innerHTML = '<div class="aa-modal__backdrop" data-close></div>' +
        '<div class="aa-modal__panel" role="dialog" aria-modal="true" aria-labelledby="aa-modal-title">' +
        '<div class="aa-modal__head"><span class="aa-modal__step" data-step></span><h2 class="aa-modal__title" id="aa-modal-title"></h2>' +
        '<button type="button" class="aa-modal__close" data-close aria-label="' + esc(T.close) + '"><svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="1.6" fill="none"/></svg></button></div>' +
        '<div class="aa-modal__tools"><label class="aa-modal__search"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5" stroke="currentColor" stroke-width="1.5" fill="none"/><path d="M15.5 15.5L21 21" stroke="currentColor" stroke-width="1.5"/></svg>' +
        '<span class="aa-visually-hidden">' + esc(T.search) + '</span><input type="search" data-q placeholder="' + esc(T.search) + '" autocomplete="off" enterkeyhint="search"></label><div class="aa-modal__extra" data-tools></div></div>' +
        '<div class="aa-modal__body"><div class="aa-pgrid" data-grid></div><div class="aa-more" data-more aria-live="polite"></div></div></div>';
      document.body.appendChild(el);
      input = el.querySelector('[data-q]');
      grid = el.querySelector('[data-grid]');
      more = el.querySelector('[data-more]');
      titleEl = el.querySelector('.aa-modal__title');
      stepEl = el.querySelector('[data-step]');
      toolsEl = el.querySelector('[data-tools]');
      el.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) close(); });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); close(); return; }
        if (e.key !== 'Tab') return;
        var f = el.querySelectorAll('button:not([disabled]), input, select');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      var t;
      input.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          st.q = input.value;
          if (norm(st.q).trim()) search(); else render();
        }, 180);
      });
      grid.addEventListener('change', function (e) {
        var sel = e.target.closest('select[data-v]');
        if (!sel) return;
        var card = sel.closest('[data-card]');
        card.querySelector('[data-err]').textContent = '';
        updateCardPrice(card);
        updateCardImg(card);
      });
      grid.addEventListener('click', function (e) {
        var b = e.target.closest('[data-pick]');
        if (b && !b.disabled) pick(b.closest('[data-card]'), b);
      });
    }

    /* ----- state ----- */
    function slot() { return st.bundle.slots[st.i]; }
    function isCase() { return slot().type === 'case'; }
    function collection() {
      if (!isCase()) return cat(slot().type).collection;
      var m = st.bundle.models.filter(function (x) { return x.model === st.model; })[0];
      return m ? m.collection : null;
    }
    function lookup(handle) {
      var all = st.items.concat(st.results || []);
      return all.filter(function (x) { return x.handle === handle; })[0];
    }
    /* does a search hit belong in this step? */
    function fits(p) {
      if (isCase()) return p.isCase && (!p.models || p.models.indexOf(st.model) > -1);
      return (p.colls || []).indexOf(collection()) > -1;
    }
    function searchPage(q, page) {
      var url = ROOT + 'search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last&view=aa-bundle-feed&page=' + page;
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('search'); return r.text(); })
        .then(function (t) { return JSON.parse(t); });
    }
    function search() {
      var q = norm(st.q).trim(), token = st.token;
      st.searching = q; st.results = null;
      render();
      var found = [];
      function step(page) {
        return searchPage(q, page).then(function (data) {
          data.products.forEach(function (p) { if (fits(p) && !found.some(function (x) { return x.handle === p.handle; })) found.push(p); });
          if (found.length < 24 && page < Math.min(data.pages, 4)) return step(page + 1);
        });
      }
      step(1).catch(function () {}).then(function () {
        if (token !== st.token || st.searching !== q) return;
        st.searching = false; st.results = found;
        render();
      });
    }

    function loadNext() {
      var coll = collection();
      if (!coll || st.loading || st.page >= st.pages) return Promise.resolve();
      st.loading = true;
      var token = st.token;
      return feed(coll, st.page + 1).then(function (data) {
        if (token !== st.token) return;
        st.loading = false;
        st.page = data.page; st.pages = data.pages;
        var seen = {};
        st.items.forEach(function (x) { seen[x.handle] = 1; });
        data.products.forEach(function (p) {
          if (seen[p.handle]) return;
          if (isCase() && !p.isCase) return;
          st.items.push(p);
        });
      }).catch(function () { if (token === st.token) { st.loading = false; st.error = true; } });
    }

    /* case prices differ per phone model and type: read them from one product of that model */
    function loadCasePrices() {
      st.typePrices = null;
      var first = st.items.filter(function (p) { return p.available; })[0];
      if (!first || !st.model) return Promise.resolve();
      var token = st.token;
      return product(first.handle).then(function (full) {
        if (token !== st.token) return;
        var tp = {}, order = [];
        full.variants.forEach(function (v) {
          if (v.option1 !== st.model || !v.option2 || (st.bundle.magsafe && !/magsafe/i.test(v.option2))) return;
          if (!(v.option2 in tp)) { tp[v.option2] = v.price; order.push(v.option2); }
        });
        st.typePrices = tp; st.types = order;
      }).catch(function () {});
    }

    /* ----- price for one card (bundle price of this item inside the current bundle) ----- */
    function cardPrice(p, variant, type) {
      var base;
      if (isCase()) base = st.typePrices && type && st.typePrices[type] != null ? st.typePrices[type] : null;
      else base = variant ? variant.price : null;
      var from = base == null;
      if (base == null) base = p.price;
      var d;
      if (slot().key === 'case2') d = Math.round(base * (CFG.secondCasePct || 0) / 100);
      else {
        var items = st.bundle.slots.map(function (s, k) {
          if (k === st.i) return { type: slot().type, price: base };
          if (s.variant) return { type: s.type, price: s.variant.price };
          /* an empty case slot still counts as "buys" for accessory discounts */
          return s.type === 'case' && !isCase() ? { type: 'case', price: 1 } : null;
        });
        d = price(items).lines[st.i] || 0;
      }
      return { orig: base, now: base - d, from: from };
    }

    function variantSelect(p, cur) {
      if (isCase()) {
        var types = st.types && st.types.length ? st.types : null;
        if (!types) return '';
        var def = cur || (types.indexOf('Shockproof') > -1 ? 'Shockproof' : types[0]);
        return '<label class="aa-pc__sel"><span class="aa-visually-hidden">' + esc(T.variantLabel.case) + '</span><select data-v="type">' +
          types.map(function (t) { return '<option value="' + esc(t) + '"' + (t === def ? ' selected' : '') + '>' + esc(t) + '</option>'; }).join('') + '</select></label>';
      }
      var vs = p.variants || [];
      if (slot().type === 'powerbank') vs = vs.filter(function (v) { return !/shell only|enkel hoesje/i.test(v.title); }); /* power bank: alleen powerbank + shell */
      if (vs.length < 2) return '';
      var last = slot().type === 'screen' ? st.bundle.caseModel() : lastName[slot().type];
      var d = cur || (last && vs.filter(function (v) { return v.available && variantName(v.title) === last; })[0]) || (slot().type === 'screen' ? null : defaultVariant(slot().type, vs));
      var label = T.variantLabel[slot().type] || T.variantLabel.def;
      return '<label class="aa-pc__sel"><span class="aa-visually-hidden">' + esc(label) + '</span><select data-v="id">' +
        (d ? '' : '<option value="">' + esc(T.chooseX + ' ' + label) + '</option>') +
        vs.map(function (v) {
          return '<option value="' + v.id + '"' + (d && d.id === v.id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + esc(variantName(v.title)) + (v.available ? '' : ' – ' + T.soldOut) + '</option>';
        }).join('') + '</select></label>';
    }
    function chosenVariant(card, p) {
      var sel = card.querySelector('select[data-v="id"]');
      var vs = p.variants || [];
      if (sel) return vs.filter(function (v) { return String(v.id) === sel.value; })[0] || null;
      var ok = vs.filter(function (v) { return v.available && !(slot().type === 'powerbank' && /shell only|enkel hoesje/i.test(v.title)); });
      if (vs.length === 1 || slot().type === 'powerbank') return ok[0] || null;
      return null;
    }
    function updateCardPrice(card) {
      var p = lookup(card.getAttribute('data-card'));
      if (!p) return;
      var typeSel = card.querySelector('select[data-v="type"]');
      var cp = cardPrice(p, chosenVariant(card, p), typeSel && typeSel.value);
      card.querySelector('[data-price]').innerHTML = priceHTML(cp.orig, cp.now, cp.from ? T.from : '');
      var hint = card.querySelector('[data-hint]');
      if (hint) {
        var v = chosenVariant(card, p);
        hint.textContent = v && T.sizeHint[variantName(v.title)] || '';
      }
    }

    /* Antwerp Avenue: show the mockup of the chosen phone + case type on case cards */
    var vimgCache = {};
    function vimg(handle) {
      if (!vimgCache[handle]) vimgCache[handle] = fetch(ROOT + 'products/' + handle + '?view=aa-vimg', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); }).then(function (d) { return (d && d.m) || {}; }).catch(function () { return {}; });
      return vimgCache[handle];
    }
    function updateCardImg(card) {
      if (!isCase() || !st.model) return;
      var model = st.model, sel = card.querySelector('select[data-v="type"]');
      var type = sel ? sel.value : ((st.types && st.types.indexOf('Shockproof') < 0 && st.types[0]) || 'Shockproof');
      vimg(card.getAttribute('data-card')).then(function (m) {
        var u = m[model + '|' + type];
        if (!u || model !== st.model) return;
        var box = card.querySelector('.aa-pc__img');
        if (!box) return;
        var im = box.querySelector('img');
        if (im) im.src = img(u, 400);
        else box.innerHTML = '<img src="' + esc(img(u, 400)) + '" alt="" loading="lazy" width="400" height="400">';
      });
    }
    function cardHTML(p) {
      var s = slot();
      var selected = s.product && s.product.handle === p.handle && s.variant;
      var curType = selected && isCase() ? (s.variant.option2 || '') : '';
      var curVar = selected && !isCase() ? s.variant : null;
      var sub = T.cat[s.key] + (isCase() && st.model ? ' · ' + st.model : '');
      var dis = !p.available;
      return '<article class="aa-pc' + (selected ? ' is-selected' : '') + '" data-card="' + esc(p.handle) + '">' +
        '<div class="aa-pc__img">' + (p.img ? '<img src="' + esc(img(p.img, 400)) + '" alt="" loading="lazy" width="400" height="400">' : '') + '</div>' +
        '<h3 class="aa-pc__title">' + esc(p.title) + '</h3>' +
        '<p class="aa-pc__sub">' + esc(sub) + '</p>' +
        '<p class="aa-pc__price" data-price></p>' +
        (dis ? '' : variantSelect(p, isCase() ? curType : curVar)) +
        (slot().type === 'sleeve' ? '<p class="aa-pc__hint" data-hint></p>' : '') +
        '<button type="button" class="aa-btn aa-btn--line" data-pick' + (dis ? ' disabled' : '') + '>' + (dis ? T.soldOut : (selected ? '✓ ' + T.added1 : T.addItem)) + '</button>' +
        '<p class="aa-pc__err" data-err role="alert"></p></article>';
    }

    function list() {
      var q = norm(st.q).trim();
      var sug = (st.bundle.suggest[slot().key] || st.bundle.suggest[slot().type] || []).filter(function (p) { return !isCase() || p.isCase !== false; });
      var seen = {}, out = [];
      if (q) return st.results || [];
      /* suggested designs (matching print) first, then the collection */
      (isCase() ? [] : sug).concat(st.items).forEach(function (p) {
        if (!p || seen[p.handle]) return;
        seen[p.handle] = 1;
        out.push(p);
      });
      if (isCase() && sug.length) {
        /* the edit's featured case goes first when it exists for this phone */
        var f = out.filter(function (p) { return sug.some(function (x) { return x.handle === p.handle; }); });
        out = f.concat(out.filter(function (p) { return f.indexOf(p) < 0; }));
      }
      return out;
    }

    function render() {
      var s = slot();
      if (isCase() && !st.model) {
        grid.innerHTML = '';
        more.innerHTML = '<p class="aa-note">' + T.modelFirst + '</p>';
        return;
      }
      var items = list();
      /* make sure suggestions are lookup-able */
      if (!isCase()) (st.bundle.suggest[s.key] || st.bundle.suggest[s.type] || []).forEach(function (p) { if (!lookup(p.handle)) st.items.unshift(p); });
      grid.innerHTML = items.map(cardHTML).join('');
      grid.querySelectorAll('[data-card]').forEach(updateCardPrice);
      grid.querySelectorAll('[data-card]').forEach(updateCardImg);
      var q = norm(st.q).trim();
      if (st.error) more.innerHTML = '<p class="aa-error">' + T.error + '</p>';
      else if (st.loading || (q && st.searching)) more.innerHTML = '<span class="aa-loading">' + T.loading + '</span>';
      else if (q && !items.length) more.innerHTML = '<p class="aa-note">' + T.noResults + '</p>';
      else if (!q && st.page < st.pages) {
        more.innerHTML = '<button type="button" class="aa-btn aa-btn--line aa-btn--auto">' + T.loadMore + '</button>';
        more.querySelector('button').addEventListener('click', function () { loadNext().then(render); render(); });
      } else more.innerHTML = '';
    }

    function renderTools() {
      if (!isCase()) { toolsEl.innerHTML = ''; return; }
      var groups = [['iphone', 'iPhone'], ['samsung', 'Samsung']];
      toolsEl.innerHTML = '<label class="aa-modal__model"><span class="aa-visually-hidden">' + T.yourPhone + '</span><select data-model>' +
        '<option value="">' + T.selectModel + '</option>' +
        groups.map(function (g) {
          var ms = st.bundle.models.filter(function (m) { return m.brand === g[0]; });
          return ms.length ? '<optgroup label="' + g[1] + '">' + ms.map(function (m) {
            return '<option value="' + esc(m.model) + '"' + (m.model === st.model ? ' selected' : '') + '>' + esc(m.model) + '</option>';
          }).join('') + '</optgroup>' : '';
        }).join('') + '</select></label>';
      toolsEl.querySelector('[data-model]').addEventListener('change', function (e) {
        st.model = e.target.value;
        store('model', st.model);
        reload();
      });
    }

    function reload() {
      st.token = {};
      st.items = []; st.page = 0; st.pages = 1; st.loading = false; st.error = false; st.typePrices = null; st.types = null; st.results = null; st.searching = false;
      if (input) input.value = '';
      st.q = '';
      render();
      var token = st.token;
      loadNext().then(function () {
        if (token !== st.token) return;
        if (isCase()) return loadCasePrices();
      }).then(function () { if (token === st.token) render(); });
    }

    function pick(card, btn) {
      var p = lookup(card.getAttribute('data-card'));
      var err = card.querySelector('[data-err]');
      err.textContent = '';
      if (!p) return;
      var s = slot();
      if (isCase()) {
        var typeSel = card.querySelector('select[data-v="type"]');
        var type = typeSel ? typeSel.value : '';
        btn.disabled = true; btn.textContent = T.loading;
        product(p.handle).then(function (full) {
          var vs = full.variants.filter(function (v) { return v.option1 === st.model && v.available && (!st.bundle.magsafe || /magsafe/i.test(v.option2 || '')); });
          var v = vs.filter(function (x) { return !type || x.option2 === type; })[0];
          if (!v) throw new Error('na');
          s.product = p; s.model = st.model;
          s.variant = { id: v.id, price: v.price, title: v.title, option2: v.option2, img: (v.featured_image && v.featured_image.src) || p.img };
          done();
        }).catch(function () {
          btn.disabled = false; btn.textContent = T.addItem;
          err.textContent = T.notForModel;
        });
        return;
      }
      var vs = p.variants || [];
      if (!vs.length) {
        /* products with many variants: resolve via the product JSON */
        btn.disabled = true;
        product(p.handle).then(function (full) {
          var v = full.variants.filter(function (x) { return x.available; })[0];
          if (!v) throw new Error('na');
          s.product = p; s.variant = { id: v.id, price: v.price, title: v.title, available: true };
          done();
        }).catch(function () { btn.disabled = false; err.textContent = T.error; });
        return;
      }
      var v = chosenVariant(card, p);
      if (!v) {
        err.textContent = T.chooseX + ' ' + (T.variantLabel[s.type] || T.variantLabel.def);
        var sel = card.querySelector('select');
        if (sel) sel.focus();
        return;
      }
      s.product = p; s.variant = v;
      lastName[s.type] = variantName(v.title);
      done();
    }

    function done() {
      var b = st.bundle;
      b.changed();
      var next = b.firstOpen(st.i);
      if (next > -1) show(b, next);
      else { close(); b.focusAdd(); }
    }

    function show(bundle, i) {
      st = { bundle: bundle, i: i, items: [], page: 0, pages: 1, loading: false, q: '', error: false, token: {}, model: '' };
      var s = slot();
      if (isCase()) st.model = s.model || bundle.model || store('model') || '';
      if (st.model && !bundle.models.some(function (m) { return m.model === st.model; })) st.model = '';
      var steps = bundle.steps();
      stepEl.textContent = (steps.indexOf(s) + 1) + '/' + steps.length;
      titleEl.textContent = T.pick[s.key];
      input.value = '';
      renderTools();
      reload();
      el.querySelector('.aa-modal__body').scrollTop = 0;
    }

    function open(bundle, i) {
      if (!el) build();
      lastFocus = document.activeElement;
      el.hidden = false;
      document.documentElement.classList.add('aa-lock');
      show(bundle, i);
      setTimeout(function () {
        var m = el.querySelector('[data-model]');
        (m && !st.model ? m : el.querySelector('.aa-modal__close')).focus();
      }, 30);
    }
    function close() {
      if (!el || el.hidden) return;
      el.hidden = true;
      st.token = {};
      document.documentElement.classList.remove('aa-lock');
      if (lastFocus && lastFocus.focus && document.body.contains(lastFocus)) lastFocus.focus();
    }
    return { open: open, close: close };
  })();

  window.AABundle = {
    cfg: CFG, t: T, cat: cat, money: money, esc: esc, img: img, variantName: variantName,
    price: price, pctFor: pctFor, feed: feed, product: product, addToCart: addToCart, picker: Picker,
    defaultVariant: defaultVariant, priceHTML: priceHTML, Bundle: Bundle, store: store
  };
  document.dispatchEvent(new CustomEvent('aa-bundle:ready'));
})();

/* =========================================================
 * Bundle overview page: prices on the bundle cards (each card links to its own bundle page)
 * Bundle detail page (/pages/bundles/<handle>): the slot list + step popup
 * ========================================================= */
(function () {
  'use strict';
  var SLOT_FROM_ADMIN = {
    'Phone case': 'case', 'Second phone case': 'case2', 'Card holder': 'cardholder', 'Sleeve': 'sleeve',
    'MacBook case': 'macbook', 'Power bank': 'powerbank', 'AirPods case': 'airpods', 'Strap or holder': 'strap',
    'Phone strap': 'strap', 'Phone holder': 'holder', 'Screen protector': 'screen'
  };

  function init() {
    var A = window.AABundle;
    if (!A) return;
    document.querySelectorAll('[data-aa-edit]:not([data-ready])').forEach(function (card) {
      card.setAttribute('data-ready', '1');
      var items = JSON.parse(card.getAttribute('data-items') || '[]');
      var p = A.price(items);
      var el = card.querySelector('[data-aa-edit-price]');
      if (el && items.length) el.innerHTML = '<span class="aa-edit__line">' + A.priceHTML(p.original, p.total, A.t.from) + '</span>';
    });
    document.querySelectorAll('[data-aa-bundle-detail]:not([data-ready])').forEach(function (root) {
      root.setAttribute('data-ready', '1');
      var d = JSON.parse(root.querySelector('[data-aa-detail-data]').textContent);
      var featured = d.featured || {};
      var suggest = {};
      var slots = (d.slots || []).map(function (name) {
        var k = SLOT_FROM_ADMIN[name] || name;
        var f = featured[k === 'case2' ? 'case' : k];
        if (f) suggest[k] = [f];
        /* slots always start empty; the featured design is shown first in the popup */
        return { key: k };
      });
      var bundle = new A.Bundle({ title: d.title, slots: slots, suggest: suggest, models: d.models || [] });
      bundle.render(root.querySelector('[data-panel]'));
    });
  }

  if (window.AABundle) init();
  document.addEventListener('aa-bundle:ready', init);
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

/* =========================================================
 * Product page: bundle cards with a big photo (swipe on mobile).
 * "Shop now" → slot list under the cards; this case is already in it.
 * ========================================================= */
(function () {
  'use strict';
  function init() {
    var A = window.AABundle;
    if (!A) return;
    document.querySelectorAll('[data-aa-pdp]:not([data-ready])').forEach(function (root) {
      root.setAttribute('data-ready', '1');
      if (root.hasAttribute('data-aa-mount')) {
        /* Rendered from custom-code-body: place it right under the buy buttons, above Addly */
        var addly = document.querySelector('[id*="addly_bundle_upsell_app_block"]');
        var form = document.querySelector('.main-product__block-buy_buttons') || document.querySelector('product-form.m-product-form--main') || document.querySelector('form[action*="/cart/add"]:not(.installment)');
        if (addly && addly.parentNode) addly.parentNode.insertBefore(root, addly);
        else if (form && form.parentNode) form.parentNode.insertBefore(root, form.nextSibling);
        else return;
      }
      new Pdp(root, A);
    });
  }

  function Pdp(root, A) {
    var self = this;
    this.A = A; this.T = A.t; this.root = root;
    var d = JSON.parse(root.querySelector('[data-aa-pdp-data]').textContent);
    this.data = d;
    this.fixed = d.fixed || 'case'; /* 'case' op een hoesje, anders bv. 'cardholder' op een kaarthouder-pagina */
    this.groups = {};
    (d.groups || []).forEach(function (g) {
      var ps = g.products.filter(function (x) { return x.available; });
      if (ps.length && A.cat(g.key)) self.groups[g.key] = ps;
    });
    var sec = root.closest('[id^="shopify-section"]') || document;
    this.form = document.querySelector('product-form.m-product-form--main form') || sec.querySelector('form[action*="/cart/add"]:not(.installment)') || document.querySelector('form[action*="/cart/add"]:not(.installment)');
    /* screen protectors only exist for some phones: hide that bundle when this phone has none */
    var cv = this.caseVariant();
    var model = cv ? String(cv.title || '').split(' / ')[0] : '';
    var screenOk = (this.groups.screen || []).some(function (p) {
      return (p.variants || []).some(function (v) { return A.variantName(v.title) === model; });
    });
    var fixed = this.fixed;
    this.edits = (d.edits || []).filter(function (e) {
      if (fixed === 'case' && e.cats.indexOf('screen') > -1 && !screenOk) return false;
      if (fixed !== 'case' && e.cats.indexOf(fixed) < 0) return false; /* accessoire-pagina: alleen bundels met dit product */
      return e.cats.length && e.cats.every(function (k) { return k === fixed || self.groups[k]; });
    }).sort(function (a, b) { return (a.order || 99) - (b.order || 99); });
    this.mode = -1;
    var refresh = function () { setTimeout(function () { self.syncCase(); }, 80); };
    document.addEventListener('change', function (e) { if (!e.target.closest('.aa-modal')) refresh(); });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.m-product-option, variant-picker, [data-option-value]')) refresh(); });
    if (!this.edits.length) { root.hidden = true; return; }
    this.render();
  }

  Pdp.prototype.caseVariant = function () {
    var id = null;
    if (this.form) { var input = this.form.querySelector('[name="id"]'); if (input) id = Number(input.value); }
    if (!id) { var m = location.search.match(/variant=(\d+)/); if (m) id = Number(m[1]); }
    var v = id && this.data.variants[id];
    if (!v) { id = this.data.current; v = this.data.variants[id]; }
    return v ? { id: id, price: v[0], available: !!v[1], img: v[2] || this.data.caseImg, title: v[3] || '' } : null;
  };
  Pdp.prototype.caseProduct = function () {
    return { handle: this.data.handle, title: this.data.title, img: this.data.caseImg };
  };

  /* "From" price per edit: this case + the cheapest product per category */
  Pdp.prototype.estimate = function (edit) {
    var self = this, A = this.A;
    var c = this.caseVariant();
    var fixed = this.fixed;
    var items = [{ type: fixed, price: c ? c.price : 0 }];
    if (fixed !== 'case') items.push({ type: 'case', price: (edit.cats.indexOf('powerbank') > -1 && this.data.caseMinMs) || this.data.caseMin || 0 });
    edit.cats.forEach(function (k) {
      if (k === fixed) return;
      var min = null;
      self.groups[k].forEach(function (p) {
        var vs = (p.variants || []).filter(function (v) { return v.available && !(k === 'powerbank' && /shell only|enkel hoesje/i.test(v.title)); });
        var pr = vs.length ? Math.min.apply(null, vs.map(function (v) { return v.price; })) : p.price;
        if (min == null || pr < min) min = pr;
      });
      items.push({ type: k, price: min });
    });
    return A.price(items);
  };

  Pdp.prototype.render = function () {
    var self = this, A = this.A, T = this.T;
    var body = this.root.querySelector('[data-aa-pdp-body]');
    body.innerHTML = '<div class="aa-rail" role="list">' + this.edits.map(function (e, i) {
      return '<article class="aa-bc" role="listitem" data-edit="' + i + '">' +
        '<div class="aa-bc__img" data-imgs></div>' +
        '<h3 class="aa-bc__title">' + A.esc(e.title) + '</h3>' +
        '<p class="aa-bc__sub">' + A.esc([T.cat.case].concat(e.cats.map(function (k) { return T.cat[k]; })).join(' + ')) + '</p>' +
        '<p class="aa-bc__price" data-price></p>' +
        '<button type="button" class="aa-btn aa-btn--line" data-build aria-expanded="false">' + T.build + '</button></article>';
    }).join('') + '</div><div class="aa-pdp__panel" data-panel hidden></div>';
    body.querySelectorAll('[data-build]').forEach(function (b) {
      b.addEventListener('click', function () { self.select(Number(b.closest('[data-edit]').getAttribute('data-edit'))); });
    });
    this.updateCards();
  };

  Pdp.prototype.updateCards = function () {
    var self = this, A = this.A, T = this.T;
    var c = this.caseVariant();
    this.root.querySelectorAll('[data-edit]').forEach(function (card) {
      var i = Number(card.getAttribute('data-edit'));
      var e = self.edits[i];
      var on = i === self.mode;
      card.classList.toggle('is-on', on);
      card.hidden = self.fixed === 'case' ? (e.cats.indexOf('powerbank') > -1 && !(c && /magsafe/i.test(c.title || ''))) /* powerbank-bundel alleen bij een MagSafe-hoesje */
        : (self.fixed === 'powerbank' && !!(c && /shell only|enkel hoesje/i.test(c.title || ''))); /* niet met 'enkel hoesje' */
      var btn = card.querySelector('[data-build]');
      btn.setAttribute('aria-expanded', String(on));
      btn.textContent = on ? '✓ ' + T.building : T.build;
      var imgs = [c && c.img].concat(e.cats.map(function (k) {
        var s = on && self.bundle && self.bundle.slots.filter(function (x) { return x.key === k; })[0];
        return (s && s.product && (s.variant && s.variant.img || s.product.img)) || (self.groups[k] && self.groups[k][0].img);
      })).filter(Boolean).slice(0, 4);
      var box = card.querySelector('[data-imgs]');
      if (e.img) {
        /* your own bundle photo (Content > Metaobjects > Bundle edit > Bundelfoto) */
        if (!box.firstChild) box.innerHTML = '<img src="' + A.esc(A.img(e.img, 700)) + '" alt="' + A.esc(e.title) + '" loading="lazy" width="700" height="700" style="width:100%;height:100%;object-fit:cover;display:block;border-radius:4px">';
      } else {
        box.innerHTML = imgs.map(function (u, n) {
          return '<img src="' + A.esc(A.img(u, 400)) + '" alt="" loading="lazy" width="400" height="400" class="aa-bc__pic aa-bc__pic--' + n + '">';
        }).join('');
        box.setAttribute('data-count', imgs.length);
      }
      var p = self.estimate(e);
      card.querySelector('[data-price]').innerHTML = A.priceHTML(p.original, p.total, T.from);
    });
  };

  Pdp.prototype.select = function (i) {
    var self = this, A = this.A;
    var panel = this.root.querySelector('[data-panel]');
    if (this.mode === i) { /* tap again = close */
      this.mode = -1; panel.hidden = true; panel.innerHTML = ''; this.bundle = null; this.updateCards(); return;
    }
    this.mode = i;
    var e = this.edits[i];
    var c = this.caseVariant();
    var fixed = this.fixed;
    var slots = [{ key: fixed, fixed: true, product: this.caseProduct(), variant: c ? { id: c.id, price: c.price, img: c.img, title: c.title } : null }];
    if (fixed !== 'case') slots.push({ key: 'case' }); /* accessoire-pagina: het hoesje kies je zelf */
    var suggest = {};
    e.cats.forEach(function (k) {
      if (k === fixed) return;
      /* empty slot; matching designs are shown first in the popup */
      suggest[k] = self.groups[k];
      slots.push({ key: k });
    });
    this.bundle = new A.Bundle({ title: e.title, slots: slots, suggest: suggest, models: this.data.models || [], onChange: function () { self.updateCards(); } });
    if (fixed === 'screen' && c) this.bundle.model = A.variantName(c.title); /* hoesje voor dezelfde gsm als de screenprotector */
    panel.hidden = false;
    this.bundle.render(panel);
    this.updateCards();
    var first = this.bundle.firstOpen(-1);
    if (first > -1) this.bundle.open(first);
    else panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

  Pdp.prototype.syncCase = function () {
    this.updateCards();
    if (!this.bundle) return;
    var c = this.caseVariant();
    var s = this.bundle.slots[0];
    s.variant = c && c.available ? { id: c.id, price: c.price, img: c.img, title: c.title } : null;
    this.bundle.render();
  };

  if (window.AABundle) init();
  document.addEventListener('aa-bundle:ready', init);
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();